import React from 'react';
import { Helmet } from 'react-helmet';
import { Analytics } from '@vercel/analytics/react';
import Home from './components/Home';
import Footer from './components/Footer';
import './App.css';

const App = () => {
  return (
    <div className="flex min-h-screen flex-col bg-ink font-mono text-fg antialiased">
      <Helmet>
        <html lang="en" />
        <title>Jonas Dormaels — Freelance IT professional</title>
        <meta
          name="description"
          content="Personal site of Jonas Dormaels — developer and builder. Connect on LinkedIn or GitHub."
        />
        <meta name="theme-color" content="#08110c" />
      </Helmet>
      <Home />
      <Footer />
      <Analytics />
    </div>
  );
};

export default App;
